function scrollCatCarousel(direction) {
  const container = document.querySelector('.custom-carousel-top-cat');
  const scrollAmount = container.offsetWidth * 0.6;
  if (direction === 'left') {
    container.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
  } else {
    container.scrollBy({ left: scrollAmount, behavior: 'smooth' });
  }
}

document.addEventListener('DOMContentLoaded', function () {
  const carousel = document.querySelector('.custom-carousel-top-cat');

  if (window.innerWidth > 768) {
    let isDragging = false;
    let startX = 0;
    let scrollLeft = 0;

    carousel.addEventListener('mousedown', (e) => {
      isDragging = true;
      startX = e.pageX - carousel.offsetLeft;
      scrollLeft = carousel.scrollLeft;
      carousel.classList.add('dragging');
    });

    ['mouseleave', 'mouseup'].forEach(evt => {
      carousel.addEventListener(evt, () => {
        isDragging = false;
        carousel.classList.remove('dragging');
      });
    });

    carousel.addEventListener('mousemove', (e) => {
      if (!isDragging) return;
      e.preventDefault();
      const x = e.pageX - carousel.offsetLeft;
      const walk = x - startX;
      carousel.scrollLeft = scrollLeft - walk;
    });
  }
});